import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SystemIntro } from './components/SystemIntro';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { WhyGlobal } from './components/WhyGlobal';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseAlerts } from './components/PurchaseAlerts';
type AppProps = {
  showUrgency?: boolean;
  showPurchaseAlerts?: boolean;
};
export function App({
  showUrgency = true,
  showPurchaseAlerts = true
}: AppProps) {
  return <div className="w-full bg-white font-sans text-ink" data-id="element-0" data-mp="28te3zgj4jfoo">
      {showPurchaseAlerts ? <PurchaseAlerts data-id="element-1" data-mp="23w4fq47h1a2f" /> : null}
      <Hero data-id="element-2" data-mp="23utby4e102bb" />
      <main data-id="element-3" data-mp="23v2uj6wqr76z">
        <PainPoints data-id="element-4" data-mp="23ti7s3go4sjo" />
        <SystemIntro data-id="element-5" data-mp="3ik7ekc2063oj" />
        <Tomos data-id="element-6" data-mp="3iiwdijzxza14" />
        <Bonuses data-id="element-7" data-mp="3ij61y35c994p" />
        <WhyGlobal data-id="element-8" data-mp="3ijpet5g4t7bv" />
        <Offer showUrgency={showUrgency} data-id="element-9" data-mp="3mlja0y7k5j4n" />
        <Testimonials data-id="element-10" data-mp="3mkhn9wh6j873" />
        <Guarantee data-id="element-11" data-mp="3mjzpgvevclx2" />
        <Faq data-id="element-12" data-mp="3mj6ipufwtwex" />
        <FinalCta showUrgency={showUrgency} data-id="element-13" data-mp="3rc9co3oln7vn" />
      </main>
      <Footer data-id="element-14" data-mp="3rcswxr1q28cu" />
    </div>;
}